import { POLICIES_URL } from "core/constants/routes";

export type IntegrationRouteParams = {
  pluginId?: string;
  datasourceId?: string;
};

export const INTEGRATION_URL = "/integrations/";
export const NEW_INTEGRATION_URL = (pluginId = ":pluginId"): string =>
  `/integrations/${pluginId}`;

export const EDIT_INTEGRATION_URL = (
  pluginId = ":pluginId",
  datasourceId = ":datasourceId",
): string => `/integrations/${pluginId}/${datasourceId}`;

export const GROUP_PAGE_URL = (
  groupId = ":groupId",
  pageType = ":pageType",
): string => `/groups/${groupId}/${pageType}`;

export const USER_PAGE_URL = (
  userId = ":userId",
  pageType = ":pageType",
): string => `/users/${userId}/${pageType}`;

export const ROLES_AND_PERMISSIONS_URL = (
  pageType: string = ":pageType",
): string => `/roles-and-permissions/${pageType}`;

export const PERMISSION_PAGE_URL = (pageType = ":pageType"): string =>
  `/permissions/${pageType}`;

export const OBSERVABILITY_PAGE_URL = (pageType = ":pageType"): string =>
  `/observability`;

export const SECRETS_MANAGEMENT_URL = `/secrets-management`;

export const APP_AI_URL = `/app-ai`;

export { POLICIES_URL, POLICY_RUN_REPORT_URL } from "core/constants/routes";

export const CLARK_KNOWLEDGE_URL = `/knowledge`;

export const CLARK_KNOWLEDGE_CREATE_URL = `/knowledge/new`;

export const CLARK_KNOWLEDGE_DETAIL_URL = (factId = ":factId"): string =>
  `/knowledge/${factId}`;

export const AI_INFERENCE_URL = `/ai-inference`;

export const DATABASE_URL = `/database`;

export const EXTERNAL_AUTH_URL = `/external-auth`;

export const EXTERNAL_EXPERIENCE_URL = `/external-experience`;

export const EXTERNAL_USERS_URL = `/external-users`;

export const FILE_STORAGE_URL = `/file-storage`;

export const IDENTITY_URL = `/identity`;

export const APP_ANALYTICS_URL = `/app-analytics`;

export const OBSERVABILITY_MONITOR_URL = `/observability-monitor`;

export const OVERVIEW_URL = `/overview`;

export const PLATFORM_SETUP_URL = `/platform-setup`;

export const WORKFLOWS_URL = `/workflows`;

export const CUSTOM_AGENT_MODELS_URL = "/custom-agent-models";

export const PACKAGE_REGISTRY_URL = `/package-registry`;

export const PLATFORM_MCP_URL = `/platform-mcp`;

export const POLICY_GATES_DEMO_URL = `/settings/policy-gates`;

export function policyAgentsHref(policyAgentsDemoEnabled: boolean): string {
  return policyAgentsDemoEnabled ? POLICY_GATES_DEMO_URL : POLICIES_URL;
}

export const SECURITY_CENTER_DEMO_URL = `/security-center-demo`;

export const SECURITY_CENTER_URL = `/security-center`;

export const SECURITY_CENTER_APPLICATION_URL = (
  applicationId = ":applicationId",
): string => `${SECURITY_CENTER_URL}/applications/${applicationId}`;

export const SECURITY_CENTER_DEMO_REVIEW_URL = (
  reviewId = ":reviewId",
): string => `${SECURITY_CENTER_DEMO_URL}/reviews/${reviewId}`;

export const NEW_SECRETS_MANAGEMENT_URL = (pluginId = ":pluginId"): string =>
  `${SECRETS_MANAGEMENT_URL}/${pluginId}`;

export const EDIT_SECRETS_MANAGEMENT_URL = (
  pluginId = ":pluginId",
  datasourceId = ":datasourceId",
): string => `${SECRETS_MANAGEMENT_URL}/${pluginId}/${datasourceId}`;

export const INVITE_USERS_TO_ORG = (orgId = ":orgId"): string =>
  `v1/organizations/${orgId}/invite`;

export const ADD_USERS_TO_ORG = (orgId = ":orgId"): string =>
  `v1/organizations/${orgId}/users`;

export const GROUPS_FOR_ORG_ID_URL = (orgId = ":orgId"): string =>
  `v1/organizations/${orgId}/groups`;

export const REPOSITORY_DETAILS_URL = (
  repositoryId = ":repositoryId",
): string => `/repositories/${repositoryId}`;

export const VERIFY_EMAIL = `v1/emails/verify`;
export const REQUEST_CODE = `v1/emails/new`;

export const CREATE_PAYMENT_INTENT = "v1/billing/create-intent";
export const SUBMIT_PAYMENT = "v1/billing/submit-payment";
export const DOWNGRADE_PLAN = "v1/billing/downgrade-free";
export const CHECK_PROMO_CODE = "v1/billing/check-promo";

export const STATUS_PAGE = "https://status.superblocks.com/";

export const PERSONAL_SETTINGS_URL = (section = ":section") =>
  `/personal-settings#${section}`;

export const GENERATE_TOKEN = "v1/token";

// for superblocks cli
export const FETCH_USER_API_KEY = "v1/users/token";
export const REVEAL_USER_API_KEY = "v1/users/token/reveal";
export const REGENERATE_USER_API_KEY = "v1/users/token/regenerate";
